<template>
  <div class="profil-container">
    <h3 class="profil-title">Halaman Pengisian Data Vendor</h3>
    <p class="profil-subtitle">Silahkan mengisi data sesuai kolom di bawah</p>

    <div class="vendor-form-wrapper">
      <div
        class="vendor-form"
        v-if="this.$store.state.landingpage.query == 'bu'"
      >
        <p class="vendor-form-label">Direktur<span class="text-ast">*</span></p>
        <div class="form-list-usaha">
          <div class="list-usaha">
            <div class="list-usaha-content list-usaha-content__title">
              <p class="column15">Jabatan</p>
              <p class="column20">Nama</p>
              <p class="column20">No. HP</p>
              <p class="column20">Email</p>
              <p class="column10">KTP</p>
            </div>
            <div v-for="(list, index) in direkturList" :key="index">
              <div class="list-usaha-content" v-if="!list.isDelete">
                <p class="column15">{{ list.jabatan }}</p>
                <p class="column20">{{ list.nama }}</p>
                <p class="column20">{{ list.phoneNumber }}</p>
                <p class="column20">{{ list.email }}</p>
                <p class="column10 all-column">
                  {{
                    $get(list, 'direkturFiles.0.name')
                      ? $get(list, 'direkturFiles.0.name', '-')
                      : list.lampiran
                  }}
                </p>
                <p class="column5" @click="editDirektur(list)">
                  <i class="fa fa-edit"></i>
                </p>
                <p class="column5" @click="deleteDirektur(list, index)">
                  <i class="fas fa-trash-alt"></i>
                </p>
              </div>
            </div>
          </div>
          <div @click="openDirekturModal()" class="btn-landing-icons">
            <p class="icons-btn-landing">+</p>
            <p class="text-btn-landing">Tambah</p>
          </div>
        </div>
      </div>

      <div
        class="vendor-form"
        v-if="this.$store.state.landingpage.query == 'bu'"
      >
        <p class="vendor-form-label">
          Komisaris<span class="text-ast">*</span>
        </p>
        <div class="form-list-usaha">
          <div class="list-usaha">
            <div class="list-usaha-content list-usaha-content__title">
              <p class="column15">Jabatan</p>
              <p class="column20">Nama</p>
              <p class="column20">No. HP</p>
              <p class="column20">Email</p>
              <p class="column10">KTP</p>
            </div>
            <div v-for="(list, index) in komisarisList" :key="index">
              <div class="list-usaha-content" v-if="!list.isDelete">
                <p class="column15">{{ list.jabatan }}</p>
                <p class="column20">{{ list.nama }}</p>
                <p class="column20">{{ list.phoneNumber }}</p>
                <p class="column20">{{ list.email }}</p>
                <p class="column10 all-column">
                  {{
                    $get(list, 'komisarisFiles.0.name')
                      ? $get(list, 'komisarisFiles.0.name', '-')
                      : list.lampiran
                  }}
                </p>
                <p class="column5" @click="editKomisaris(list)">
                  <i class="fa fa-edit"></i>
                </p>
                <p class="column5" @click="deleteKomisaris(list, index)">
                  <i class="fas fa-trash-alt"></i>
                </p>
              </div>
            </div>
          </div>
          <div @click="openKomisarisModal()" class="btn-landing-icons">
            <p class="icons-btn-landing">+</p>
            <p class="text-btn-landing">Tambah</p>
          </div>
        </div>
      </div>

      <div
        class="vendor-form"
        v-if="this.$store.state.landingpage.query == 'bu'"
      >
        <p class="vendor-form-label">
          Pemilik Saham
        </p>
        <div class="form-list-usaha">
          <div class="list-usaha">
            <div class="list-usaha-content list-usaha-content__title">
              <p class="column40">Nama Pemegang Saham</p>
              <p class="column50">% Saham</p>
            </div>
            <div
              class="list-usaha-content"
              v-for="(list, index) in pemilikSahamList"
              :key="index"
            >
              <p class="column40">{{ list.nama }}</p>
              <p class="column50">{{ list.saham }}</p>
              <p class="column5" @click="editPemilikSaham(list)">
                <i class="fa fa-edit"></i>
              </p>
              <p class="column5" @click="deletePemilikSaham(list)">
                <i class="fas fa-trash-alt"></i>
              </p>
            </div>
          </div>
          <div @click="openPemilikSahamModal()" class="btn-landing-icons">
            <p class="icons-btn-landing">+</p>
            <p class="text-btn-landing">Tambah</p>
          </div>
        </div>
      </div>

      <div
        class="vendor-form"
        v-if="this.$store.state.landingpage.query == 'bu'"
      >
        <p class="vendor-form-label">
          Person In Charge
        </p>
        <div class="form-list-usaha">
          <div class="list-usaha">
            <div class="list-usaha-content list-usaha-content__title">
              <p class="column50">Nama</p>
              <p class="column20">No. Handphone</p>
              <p class="column20">Email</p>
            </div>
            <div
              class="list-usaha-content"
              v-for="(list, index) in picList"
              :key="index"
            >
              <p class="column50">{{ list.nama }}</p>
              <p class="column20">{{ list.phoneNumber }}</p>
              <p class="column20">{{ list.email }}</p>
              <p class="column5" @click="editPic(list)">
                <i class="fa fa-edit"></i>
              </p>
              <p class="column5" @click="deletePic(list)">
                <i class="fas fa-trash-alt"></i>
              </p>
            </div>
          </div>
          <div @click="openPicModal()" class="btn-landing-icons">
            <p class="icons-btn-landing">+</p>
            <p class="text-btn-landing">Tambah</p>
          </div>
        </div>
      </div>

      <div>
        <div>
          Apakah Anda memiliki hubungan keluarga dengan pemilik atau pejabat
          yang berwenang di Sinarmas Mining Group:
        </div>
        <div class="vendor-form">
          <div class="input-20">
            <input type="radio" name="ya" value="ya" v-model="pick" />
            <label class="ml20" for="ya">Ya</label>
          </div>
          <div class="input-20">
            <input type="radio" name="tidak" value="tidak" v-model="pick" />
            <label class="ml20" for="tidak">Tidak</label>
          </div>
        </div>
      </div>

      <div v-if="pick == 'ya'">
        <div class="vendor-form">
          <div class="input-20">
            <input type="checkbox" value="1" v-model="afiliasi_gems" />
            <label class="ml20">GEMS</label>
          </div>
          <div class="input-20">
            <input type="checkbox" value="1" v-model="afiliasi_bce" />
            <label class="ml20">BCE</label>
          </div>
          <div class="input-20">
            <input type="checkbox" value="1" v-model="afiliasi_bkes" />
            <label class="ml20">BKES</label>
          </div>
        </div>
      </div>

      <div class="vendor-form100" v-if="pick == 'ya'">
        <div>
          <div class="vendor-form100">
            <div class="label-100">
              Jelaskan hubungan dengan Sinarmas Mining Group!<span
                class="text-ast"
                >*</span
              >
            </div>
            <textarea
              class="input-100"
              v-model="relasi_desc"
              oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
            />
          </div>

          <div class="vendor-form100">
            <div class="label-100">
              Apa nama Group Keluarga Anda di Sinarmas Mining Group?
            </div>
            <textarea
              class="input-100"
              v-model="relasi_group"
              oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
            />
          </div>

          <div class="vendor-form100">
            <div class="label-100 mb10">
              Identitas Nama Orang yang Bersangkutan dengan Anda
            </div>
            <div class="vendor-form">
              <p class="vendor-form-label">Nama</p>
              <input
                type="text"
                class="vendor-input"
                v-model="relasi_nama"
                oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
              />
            </div>

            <div class="vendor-form">
              <p class="vendor-form-label">Jabatan</p>
              <input
                type="text"
                class="vendor-input"
                v-model="relasi_jabatan"
                oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
              />
            </div>

            <div class="vendor-form">
              <p class="vendor-form-label">Departemen</p>
              <input
                type="text"
                class="vendor-input"
                v-model="relasi_departemen"
                oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goLegalitas()" class="btn-landing">Selanjutnya</div>
    </div>

    <addDirektur
      v-if="
        $store.state.landingpage.addDirektur ||
          $store.state.landingpage.editDirektur
      "
    />
    <addKomisaris
      v-if="
        $store.state.landingpage.addKomisaris ||
          $store.state.landingpage.editKomisaris
      "
    />
    <addPemilikSaham
      v-if="
        $store.state.landingpage.addPemilikSaham ||
          $store.state.landingpage.editPemilikSaham
      "
    />
    <addPic
      v-if="$store.state.landingpage.addPic || $store.state.landingpage.editPic"
    />
  </div>
</template>

<script>
export default {
  name: 'alamat',
  components: {
    addDirektur: () => import('@/components/modalLandingPage/addDirektur.vue'),
    addKomisaris: () =>
      import('@/components/modalLandingPage/addKomisaris.vue'),
    addPemilikSaham: () =>
      import('@/components/modalLandingPage/addPemilikSaham.vue'),
    addPic: () => import('@/components/modalLandingPage/addPic.vue'),
  },
  data() {
    return {}
  },
  computed: {
    pick: {
      get() {
        return this.$store.state.landingpage.pick
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'pick',
          value: newValue,
        })
      },
    },
    afiliasi_gems: {
      get: function() {
        return this.$store.state.landingpage.afiliasi_gems
      },
      set: function(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'afiliasi_gems',
          value: newValue,
        })
      },
    },
    afiliasi_bce: {
      get: function() {
        return this.$store.state.landingpage.afiliasi_bce
      },
      set: function(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'afiliasi_bce',
          value: newValue,
        })
      },
    },
    afiliasi_bkes: {
      get: function() {
        return this.$store.state.landingpage.afiliasi_bkes
      },
      set: function(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'afiliasi_bkes',
          value: newValue,
        })
      },
    },
    direkturList: function() {
      console.log('direktur list: ', this.$store.state.landingpage.direkturList)
      return this.$store.state.landingpage.direkturList
    },
    komisarisList: function() {
      return this.$store.state.landingpage.komisarisList
    },
    pemilikSahamList: function() {
      return this.$store.state.landingpage.pemilikSahamList
    },
    picList: function() {
      return this.$store.state.landingpage.picList
    },
    relasi_desc: {
      get() {
        return this.$store.state.landingpage.relasi_desc
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'relasi_desc',
          value: newValue,
        })
      },
    },
    relasi_group: {
      get() {
        return this.$store.state.landingpage.relasi_group
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'relasi_group',
          value: newValue,
        })
      },
    },
    relasi_nama: {
      get() {
        return this.$store.state.landingpage.relasi_nama
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'relasi_nama',
          value: newValue,
        })
      },
    },
    relasi_jabatan: {
      get() {
        return this.$store.state.landingpage.relasi_jabatan
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'relasi_jabatan',
          value: newValue,
        })
      },
    },
    relasi_departemen: {
      get() {
        return this.$store.state.landingpage.relasi_departemen
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'relasi_departemen',
          value: newValue,
        })
      },
    },
  },
  methods: {
    checkForm() {
      let arr = [
        [this.direkturList.length > 0, 'Direktur'],
        [this.komisarisList.length > 0, 'Komisaris'],
      ]

      if (this.pick == 'ya') {
        arr = [
          ...arr,
          [
            this.afiliasi_gems || this.afiliasi_bce || this.afiliasi_bkes,
            'Bisnis Unit',
          ],
          [
            this.$store.state.landingpage.relasi_desc,
            'Jelaskan hubungan dengan Sinarmas Mining Group!',
          ],
        ]
      }

      if (
        this.$get(this.$store, 'state.landingpage.type_pendaftaran_id') == 1
      ) {
        return this.multiConditions(arr)
      }
      return true
    },
    checkFormPerorangan() {
      let arr = []

      if (this.pick == 'ya') {
        arr = [
          ...arr,
          [
            this.afiliasi_gems || this.afiliasi_bce || this.afiliasi_bkes,
            'Bisnis Unit',
          ],
          [
            this.$store.state.landingpage.relasi_desc,
            'Jelaskan hubungan dengan Sinarmas Mining Group!',
          ],
        ]
      }

      return this.multiConditions(arr)
    },
    goBack() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'bank')
    },
    goLegalitas() {
      const query = this.$store.state.landingpage.query

      if (query == 'bu') {
        if (this.checkForm()) {
          this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'legalitasbu')
          this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'legal_step',
            value: true,
          })
        }
      } else if (query == 'perorangan') {
        if (this.checkFormPerorangan()) {
          this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'legalitas')
          this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'legal_step',
            value: true,
          })
        }
      } else {
        this.$router.push('/')
      }
    },
    openDirekturModal() {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addDirektur',
        value: true,
      })
    },
    editDirektur(list) {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'idDirektur',
        value: list.id,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'jabatanDirektur',
        value: list.jabatan,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'namaDirektur',
        value: list.nama,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'phoneDirektur',
        value: list.phoneNumber,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'emailDirektur',
        value: list.email,
      })
      if (list.lampiran) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'direkturLampiran',
          value: list.lampiran,
        })
      }
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'direkturFiles',
        value: list.direkturFiles,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'editDirektur',
        value: true,
      })
    },
    deleteDirektur(list, index) {
      let deleted = {
        ...list,
        isDelete: true,
      }
      if (list.jabatan == 'DIREKTUR UTAMA') {
        this.$store.commit('SET_NOTIF', 'Direktur Utama hanya bisa di edit.')
      } else {
        this.$store.commit('landingpage/SET_ARRAY_DATA', {
          name: 'direkturList',
          value: list.id,
          index,
          deleted,
          operation: 'delete',
        })
      }
    },
    openKomisarisModal() {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addKomisaris',
        value: true,
      })
    },
    editKomisaris(list) {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'idKomisaris',
        value: list.id,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'jabatanKomisaris',
        value: list.jabatan,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'namaKomisaris',
        value: list.nama,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'phoneKomisaris',
        value: list.phoneNumber,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'emailKomisaris',
        value: list.email,
      })
      if (list.lampiran) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'komisarisLampiran',
          value: list.lampiran,
        })
      }
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'komisarisFiles',
        value: list.komisarisFiles,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'editKomisaris',
        value: true,
      })
    },
    deleteKomisaris(list, index) {
      let deleted = {
        ...list,
        isDelete: true,
      }
      if (list.jabatan == 'KOMISARIS UTAMA') {
        this.$store.commit('SET_NOTIF', 'Komisaris Utama hanya bisa di edit.')
      } else {
        this.$store.commit('landingpage/SET_ARRAY_DATA', {
          name: 'komisarisList',
          value: list.id,
          deleted,
          index,
          operation: 'delete',
        })
      }
    },
    openPemilikSahamModal() {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addPemilikSaham',
        value: true,
      })

      if (this.$store.state.landingpage.pemilikSahamList.length > 0) {
        let totalSaham = this.$sum(
          this.$store.state.landingpage.pemilikSahamList,
          'saham'
        )

        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'totalSaham',
          value: Number(totalSaham),
        })
      }
    },
    editPemilikSaham(list) {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'idPemilikSaham',
        value: list.id,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'namaPemilikSaham',
        value: list.nama,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'sahamPemilikSaham',
        value: list.saham,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'editPemilikSaham',
        value: true,
      })

      if (this.$store.state.landingpage.pemilikSahamList.length > 0) {
        let totalSaham = this.$sum(
          this.$store.state.landingpage.pemilikSahamList,
          'saham'
        )

        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'totalSaham',
          value: Number(totalSaham) - Number(list.saham),
        })
      }
    },
    deletePemilikSaham(list) {
      this.$store.commit('landingpage/SET_ARRAY_DATA', {
        name: 'pemilikSahamList',
        value: list.id,
        operation: 'delete',
      })
    },
    openPicModal() {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addPic',
        value: true,
      })
    },
    editPic(list) {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'idPic',
        value: list.id,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'namaPic',
        value: list.nama,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'phonePic',
        value: list.phoneNumber,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'emailPic',
        value: list.email,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'editPic',
        value: true,
      })
    },
    deletePic(list) {
      this.$store.commit('landingpage/SET_ARRAY_DATA', {
        name: 'picList',
        value: list.id,
        operation: 'delete',
      })
    },
  },
}
</script>
